import { Text, useDisclosure, VStack } from '@chakra-ui/react';
import React from 'react';
import { useQueryClient } from 'react-query';
import { Navigate } from 'react-router-dom';
import { Column } from 'react-table';

import { TypeUtils } from '../../../../framework/utils/UtilityTypes';
import ClickableText from '../../../components/ClickableText';
import StyledTable from '../../../components/StyledTable';
import { pageNames, pagePaths } from '../../../constants/Page';
import { useGlobalStateMachine } from '../../../GlobalStore';
import { NOTICE_CONTEXT_NAMES } from '../../../hooks/queries/notice';
import { Notice } from '../../../models/gen/notice';
import { NoticeSearchResult } from '../../../models/gen/noticeSearchResult';
import { Formatter } from '../../../utils/FormatUtils';
import { NotificationDetailModal } from '../../modals/NotificationDetail';
import { useSizeContext } from '../../SizeProvider';
import Wireframe from '../../wireframe/Wireframe';
import NotificationSearchForm from './SearchForm';

type DatasourceType = Pick<
  Notice,
  'noticeId' | 'subject' | 'dateFrom' | 'dateTo'
>;

/**
 * お知らせ検索画面
 * @returns
 */
const Notification: React.FunctionComponent = () => {
  const { state } = useGlobalStateMachine();
  if (TypeUtils.isNil(state.userInfo)) {
    return <Navigate to={pagePaths.ROOT} />;
  }

  const sizes = useSizeContext();
  const queryClient = useQueryClient();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [selectedNoticeId, setSelectedNoticeId] = React.useState<number>();

  const searchResults = queryClient.getQueryData<NoticeSearchResult>(
    NOTICE_CONTEXT_NAMES.POST_NOTICE_SEARCH
  );
  const columns: ReadonlyArray<Column<DatasourceType>> = [
    {
      Header: 'タイトル',
      accessor: 'subject',
    },
    {
      Header: '表示期間',
    },
  ];

  return (
    <Wireframe title={pageNames.NOTIFICATION}>
      <VStack
        backgroundColor="white"
        padding={2}
        paddingBottom={5}
        width={sizes.width.styledMessageList}
      >
        <NotificationSearchForm />
        <StyledTable
          columns={columns}
          customizeRender={({ cell, data: original }) =>
            cell.column.id === 'subject' ? (
              <ClickableText
                onClick={() => {
                  setSelectedNoticeId(original.noticeId);
                  onOpen();
                }}
              >
                {cell.render('Cell')}
              </ClickableText>
            ) : (
              <Text>
                {Formatter.date(original.dateFrom, false, '―')} ～{' '}
                {Formatter.date(original.dateTo, false, '―')}
              </Text>
            )
          }
          data={searchResults?.results || []}
        />
      </VStack>

      <NotificationDetailModal
        isOpen={isOpen}
        noticeId={selectedNoticeId}
        onClose={onClose}
      />
    </Wireframe>
  );
};

export default Notification;
